<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let label = null
    export let value = null
    export let placeholder = ''
    export let pattern = null

    export let required = true
    export let type = 'text'
    export let name = null
    export let autocomplete = null
    export let inputmode = null

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        {#if type === 'password'}
            <input
                bind:value={value}
                on:keyup
                on:keyup={e => e.code === 'Enter' && dispatch('enter')}
                class="input"
                type="password"
                {pattern}
                {placeholder}
                {required}
                {name}
                {autocomplete}
                {inputmode}
            >
        {:else if type === 'email'}
            <input
                bind:value={value}
                on:keyup
                on:keyup={e => e.code === 'Enter' && dispatch('enter')}
                class="input"
                type="email"
                {pattern}
                {placeholder}
                {required}
                {name}
                {autocomplete}
                {inputmode}
            >
        {:else}
            <input
                bind:value={value}
                on:keyup
                on:keyup={e => e.code === 'Enter' && dispatch('enter')}
                class="input"
                type="text"
                {pattern}
                {placeholder}
                {required}
                {name}
                {autocomplete}
                {inputmode}
            >
        {/if}
    </div>
</div>
